import api from '@app/utils/api';

export const fetchCorporateRequests = (body) => {
  return api.post('/owner/help-desk/corporates/requests', body);
};

export const updateCorporateRequest = (body) => {
  return api.post('/owner/help-desk/corporates/invites/update-status', body);
};
